import { useSelector } from 'react-redux';
import {
  selectActionUrl,
  selectCalculatorErrors,
  selectIsOffersExist,
  selectMasterButton,
} from '../../../selectors/landing';
import cn from 'clsx';
import * as styles from './styles.css';
import { ContainerInner } from '../../../components/ContainerInner';
import { Button, UIText2 } from '@cian/ui-kit';
import React, { useCallback } from 'react';
import { useAuthorized } from '../../../hooks/useAuthorized';
import { EFillApplicationStickyButtonType } from './types';
import { ScrollUpButtonContainer } from '../ScrollUpButtonContainer';
import { NBSP } from 'shared/constants/common';

export interface IFillApplicationButtonMobileProps {
  handleOnload: (node: HTMLElement | null) => void;
}

export const FillApplicationButtonMobile: React.FC<IFillApplicationButtonMobileProps> = ({ handleOnload }) => {
  const isOffersExist = useSelector(selectIsOffersExist);
  const calculatorErrors = useSelector(selectCalculatorErrors);
  const enabledButton = useSelector(selectMasterButton);
  const { authorizeAndRedirect } = useAuthorized();
  const masterButtonActionUrl = useSelector(selectActionUrl) as string;

  const handleClick = useCallback(() => {
    authorizeAndRedirect({
      path: masterButtonActionUrl,
      analyticEventKey: EFillApplicationStickyButtonType.TOP,
    });
  }, [masterButtonActionUrl]);

  if (!isOffersExist || calculatorErrors.length > 0) {
    return null;
  }

  return (
    <div
      className={cn(styles['mobile-btn'], enabledButton === EFillApplicationStickyButtonType.TOP && styles['active'])}
      ref={handleOnload}
    >
      <div className={styles['scroll-up']}>
        <ScrollUpButtonContainer />
      </div>
      <ContainerInner>
        <div className={styles['mobile-wrapper']}>
          <Button fullWidth size="M" onClick={handleClick}>
            Заполнить заявку на Циане
          </Button>
          <div className={styles.textContainer}>
            <UIText2 textAlign="center" color="text-secondary-default">
              Заявка{NBSP}— единая для всех банков.
            </UIText2>
            <UIText2 textAlign="center" color="text-secondary-default">
              Перед заполнением попросим авторизоваться.
            </UIText2>
          </div>
        </div>
      </ContainerInner>
    </div>
  );
};
